import { cancelSubscription } from "@campgladiator/cg-common.api.subscriptions";
import { getCancelDate } from "@campgladiator/cg-common.logic.subscriptions";
import {
  CancellationReason,
  Role,
  SubscriptionDTO,
} from "@campgladiator/cg-common.types.types";
import { ButtonProps } from "@campgladiator/cgui-core.atoms.button";
import { useEffect, useState } from "react";

export type UseMembershipManagementCancelProps = {
  onClose?: (success?: boolean) => void;
  subscription: SubscriptionDTO;
  role: Role;
  token: string;
  theme: ButtonProps["theme"];
};

const useMembershipManagementCancel = ({
  onClose,
  subscription,
  token,
  theme,
}: UseMembershipManagementCancelProps) => {
  const [
    isCancelSubscriptionModalVisible,
    setIsCancelSubscriptionModalVisible,
  ] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const cancelAtDate = getCancelDate(subscription);

  const onFormSubmit = (reason?: CancellationReason) => {
    setIsLoading(true);
    cancelSubscription(subscription.id, cancelAtDate, reason, token)
      .then((isOk) => onClose(isOk))
      .catch(() => onClose(false))
      .finally(() => setIsLoading(false));
  };

  const membershipManagementCancelModalProps = {
    isVisible: isCancelSubscriptionModalVisible,
    onClose,
    subscription,
    onFormSubmit,
    isLoading,
    cancelAtDate,
    theme,
  };

  useEffect(() => {
    setIsCancelSubscriptionModalVisible(true);
  }, [subscription]);

  return {
    membershipManagementCancelModalProps,
  };
};

export default useMembershipManagementCancel;
